import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import preview from './preview/marketplace_component/marketplace_component.png';
import thumbnail from './preview/marketplace_component/marketplace_component_thumbnail.png';

CustomViewPages.register({
  id: 'marketplace_component',
  meta: {
    label: 'Component Detail Page',
    category: CustomViewPageCategory.MARKETPLACE,
    typeId: {
      type: CustomViewTypeIdType.COMPONENT_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.COMPONENT_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  function: function Entity() {
    const configApi = useApi(configApiRef);
    const dataSharingAgreementFieldName =
      configApi.getOptionalString(
        'mesh.marketplace.ui.outputPortPage.dataSharingAgreementField',
      ) ?? 'dataSharingAgreement';
    return (
      <>
        <CustomViewComponent type="grid_list">
          <CustomViewComponent
            type="marketplace_data_contract_error_panel"
            path="_dataContractStatus"
          />
          <CustomViewComponent
            type="include"
            id="marketplace_component_general"
          />
          <CustomViewComponent
            type="grid_sequence"
            path="_componentsByKind"
            showWhenExists="components"
            showWhen={{
              value: '{{ components | some("consumable", true) }}',
              equals: 'true',
            }}
          >
            <CustomViewComponent
              type="card"
              title="{{ label }}"
              showWhen={{
                value: '{{ components | some("consumable", true) }}',
                equals: 'true',
              }}
            >
              <CustomViewComponent
                type="table"
                showRowWhen={{ value: '{{ consumable }}', notEquals: false }}
                click="showSubcomponent"
                path="components"
              >
                <CustomViewComponent
                  type="string"
                  value="{{ name }}"
                  label="Name"
                />
                <CustomViewComponent
                  type="string"
                  value="{{ description }}"
                  label="Description"
                />
                <CustomViewComponent
                  type="string"
                  value="{{ technology }}"
                  label="Technology"
                />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
          <CustomViewComponent type="marketplace_data_contract_policy_status" />
          <CustomViewComponent type="marketplace_tech_card" />
          <CustomViewComponent
            type="card"
            title="Data Contract"
            showWhenExists={['dataContract.SLA', 'dataContract.schema[0]']}
          >
            <CustomViewComponent
              type="sub_card"
              title="SLA"
              showWhenExists="dataContract.SLA"
            >
              <CustomViewComponent type="container">
                <CustomViewComponent type="new_root" path="dataContract.SLA">
                  <CustomViewComponent
                    label="upTime"
                    type="string"
                    path="upTime"
                    showWhenExists="upTime"
                  />
                  <CustomViewComponent
                    label="timeliness"
                    type="string"
                    path="timeliness"
                    showWhenExists="timeliness"
                  />
                  <CustomViewComponent
                    label="interval of change"
                    type="string"
                    path="intervalOfChange"
                    showWhenExists="intervalOfChange"
                  />
                </CustomViewComponent>
                <CustomViewComponent
                  label="Terms and Conditions"
                  type="string"
                  path="dataContract.termsAndConditions"
                  showWhenExists="dataContract.termsAndConditions"
                  colSpan={4}
                />
              </CustomViewComponent>
            </CustomViewComponent>
            <CustomViewComponent type="schema_list" path="dataContract.schema">
              <CustomViewComponent type="grid_sequence" path="">
                <CustomViewComponent type="card" title="{{ name }}">
                  <CustomViewComponent
                    type="table"
                    path="columns"
                    treeview="children"
                    hideEmptyColumns
                  >
                    <CustomViewComponent
                      type="string"
                      path="dataType"
                      width="15%"
                      label="Type"
                    />
                    <CustomViewComponent
                      type="string"
                      path="name"
                      width="30%"
                      label="Name"
                    />
                    <CustomViewComponent
                      type="string"
                      path="description"
                      width="40%"
                      label="Description"
                    />
                    <CustomViewComponent
                      type="tags"
                      path="tags"
                      width="10%"
                      label="Tags"
                    />
                    <CustomViewComponent
                      type="tags"
                      path="businessTerms"
                      width="10%"
                      label="Business Terms"
                    />
                    <CustomViewComponent
                      type="row_link"
                      label="Semantic Link"
                      path="_semanticlink"
                      width="5%"
                      click="showSemanticLink"
                    />
                  </CustomViewComponent>
                </CustomViewComponent>
                <CustomViewComponent type="vspace" />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
          <CustomViewComponent
            showWhenExists={dataSharingAgreementFieldName}
            type="card"
            title="Data Sharing Agreement"
          >
            <CustomViewComponent type="container">
              <CustomViewComponent
                type="automatic_fields_list"
                path={dataSharingAgreementFieldName}
                defaults={{ _default: { colSpan: '2' } }}
              />
            </CustomViewComponent>
          </CustomViewComponent>
          <CustomViewComponent type="data_preview" title="Data Preview" />
        </CustomViewComponent>
      </>
    );
  },
});
